module.exports = __webpack_public_path__ + "media/private_home/CLOSEOUT_DEALS-f2c970aa.jpg";